import {useNavigate, useSearchParams} from 'react-router-dom'

import Style from './style'

import MainHeader from 'widget/MainHeader'
import Pagenation from 'widget/Pagenation'

import useGetExamVersionList from 'entity/exam/useGetExamVersionList'
import {examTabList} from 'shared/constant/common.constant'
import timestampCalculator from 'shared/lib/timestampCalculator'
import TStyle from 'shared/style/tableStyle'
import TableLoading from 'shared/ui/TableLoading'
import useRoleCookie from 'shared/model/useRoleCookie'
import {ROLE_COMPETITION_MANAGER} from 'shared/constant/lookup/role'

const TryoutExamVersionList = () => {
	const navigate = useNavigate()
	const [searchParams, setSearchParams] = useSearchParams()
	const proGrade = searchParams.get('proGrade')

	const [examList, isLoading] = useGetExamVersionList()
	const sizeList = ['short', 'expand', 'expand', 'expand']
	const tableHeadList = ['번호', '회차', '최신 상태', '생성일']
	const [userRole] = useRoleCookie()
	const showBackBtn = userRole !== ROLE_COMPETITION_MANAGER

	const clickTabEvent = (value) => {
		searchParams.set('proGrade', value)
		setSearchParams(searchParams)
	}

	return (
		<Style.Wrapper>
			{showBackBtn ? (
				<MainHeader title='모의고사 회차 목록' navigateLink='/exam' />
			) : (
				<MainHeader>모의고사 회차 목록</MainHeader>
			)}

			<Style.TabDiv>
				{examTabList.map((elem, index) => (
					<Style.Tab
						key={index}
						$selected={proGrade === elem}
						onClick={() => clickTabEvent(elem)}
					>
						{elem}
					</Style.Tab>
				))}
			</Style.TabDiv>

			<TableLoading isLoading={isLoading}>
				<TStyle.TableDiv>
					<TStyle.TableInner>
						<TStyle.TableRow $title>
							{tableHeadList.map((elem, index) => (
								<TStyle.Data key={index} $title $size={sizeList[index]}>
									{elem}
								</TStyle.Data>
							))}
						</TStyle.TableRow>
						{examList?.data?.exam_list?.map((elem, index) => (
							<TStyle.TableRow
								key={index}
								$odd={index % 2 === 1}
								onClick={() => navigate(`/exam/${elem?.idx}/detail`)}
							>
								<TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
								<TStyle.Data $size={sizeList[1]}>
									회차 {elem?.version}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[2]}>
									{index === 0 ? '예' : ''}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[3]}>
									{timestampCalculator(elem?.created_at)}
								</TStyle.Data>
							</TStyle.TableRow>
						))}
					</TStyle.TableInner>
				</TStyle.TableDiv>
			</TableLoading>

			<Pagenation maxPage={examList?.data?.max_page} />
			{/* {isOpenModal && (
				<QualificationExamModal closeEvent={() => setIsOpenModal(false)} />
			)} */}
		</Style.Wrapper>
	)
}

export default TryoutExamVersionList
